var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Training"}},[_c('TrainingTab')],1),_c('b-tab',{attrs:{"title":"Policies"}},[_c('PoliciesTab')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }